var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('path',{attrs:{"d":`M${_vm.pathCoordinate}`,"fill-opacity":_vm.opacity,"transform":_vm.transformAttribute}})
}
var staticRenderFns = []

export { render, staticRenderFns }